import React from "react";
import { DonateWidget } from "services/main/donate.service";
import { PublicWidgetNode, type PublicGridItem } from "pages/donations/DonationWidgetPublicPage";
import type { FlowEditorNode } from "./types";
import { buildGridItemData, getDonateWidgetTypeFromKind } from "./flowUtils";

export const getPublicPreviewItem = (node: FlowEditorNode): PublicGridItem => {
  const kind = node.data.kind || "text";

  return {
    id: node.id,
    type: getDonateWidgetTypeFromKind(kind),
    title: node.data.label || "Widget",
    data: buildGridItemData(node),
    settings: node.data.settings || {},
    styles: {
      color: node.data.color,
    },
  };
};

export const getPublicPreviewWidget = (node: FlowEditorNode): DonateWidget => {
  const kind = node.data.kind || "text";

  return {
    name: node.data.label || "Widget",
    type: getDonateWidgetTypeFromKind(kind),
    status: "ACTIVE",
    metadata: {
      widgetKey: kind,
      source: "donate-portal-preview",
    },
    settings: {},
    styles: {},
  };
};

export const getPublicPreviewSearchParams = (node: FlowEditorNode) => {
  const settings = node.data.settings || {};
  const params = new URLSearchParams({ preview: "1" });

  if (node.data.kind === "alert") {
    params.set("name", String(settings.name || "Bibilie"));
    params.set(
      "amount",
      String(settings.amount || settings.minAmount || 25000),
    );
    params.set("message", String(settings.message || "Nice stream!"));
  }

  return params;
};

export function FlowNodePreview({ node }: { node: FlowEditorNode }) {
  return (
    <div className="pointer-events-none h-full w-full">
      <PublicWidgetNode
        widget={getPublicPreviewWidget(node)}
        item={getPublicPreviewItem(node)}
        searchParams={getPublicPreviewSearchParams(node)}
        previewMode
      />
    </div>
  );
}

